import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { Menu } from '../menu/menu';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from '../profile/profile.component';
import { HeaderService } from '../../services/header.service';
import { AuthService } from '../../services/auth.services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [Menu, CommonModule, ProfileComponent],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header implements OnInit {
  router: Router = inject(Router);
  cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  @Input() title!: string;
  @Input() subtitle?: string;
  @Input() signature?: string;
  @Input() searchBar: boolean = false;

  @Input() logo: string = 'imgs/logoms.png';

  @Input() features: {
    title: string;
    links: {
      label: string;
      icon: string;
      route?: string;
      url?: string;
    }[];
  } | null = { title: '', links: [] };

  @Input() links: {
    label: string;
    route?: string;
    url?: string;
  }[] = [];

  showLinks = false;
  showFunctions = false;
  showSearchBar = false;
  isAuthenticated = false;
  isUserMenuHidden = true;

  private headerService = inject(HeaderService);
  private authService = inject(AuthService);

  ngOnInit(): void {
    this.headerService.profileSubject.subscribe({
      next: (profile) => {
        setTimeout(() => {
          this.isAuthenticated = profile != null;
          this.cdr.detectChanges();
        });
      },
    });
  }

  startSession(): void {
    this.router.navigate(['/login']);
  }

  endSession(): void {
    this.authService.logout();
  }
}
